export enum MimeType {
  CSV = 'text/csv;charset=UTF-8',
  JSON = 'application/json;charset=UTF-8',
  ZIP = 'application/zip;charset=UTF-8',
  XML = 'application/xml;charset=UTF-8',
  HTML = 'text/html;charset=UTF-8',
  PLAIN_TEXT = 'text/plain;charset=UTF-8',
}

export const mimeTypeToExtension = new Map<MimeType, string>([
  [MimeType.CSV, 'csv'],
  [MimeType.JSON, 'json'],
  [MimeType.ZIP, 'zip'],
  [MimeType.XML, 'xml'],
  [MimeType.HTML, 'html'],
  [MimeType.PLAIN_TEXT, 'txt'],
]);
